import { render, staticRenderFns } from "./new-patient-form.vue?vue&type=template&id=492e413c&"
import script from "./new-patient-form.vue?vue&type=script&lang=js&"
export * from "./new-patient-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports